// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__eV161","footer":"styles_footer__2TVYd"};